module.exports = __webpack_public_path__ + "img/call-dail.a6809933.svg";